// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  text-align: center;
}
/* Bara de navigare */
.OrderReview_content__6SzFz {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  flex-direction: column; /* Elemente pe verticală */
}

.OrderReview_cartList__WcVyE {
  width: 71%;
}

.OrderReview_orderSummary__dDda3 {
  width: 29%;
}

.OrderReview_inlineContainer__pyz\\+4 {
  display: flex;
  margin: 20px 0;
  justify-content: space-between; /* Spațiu între elemente */
  align-items: top; /* Aliniere pe verticală */
  width: 100%; /* Lățime completă */
  gap: 20px;
}

.OrderReview_continueButton__5cVY4 {
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  color: inherit;
  font-weight: normal;
}

.OrderReview_continueButton__5cVY4:hover {
  background-color: #f8f8f8;
  border-color: #ccc;
}

.OrderReview_continueButton__5cVY4 i {
  padding: 7px;
}

/* Responsive */
@media (max-width: 768px) {
  * {
    padding: 0;
    gap: 0;
    margin: 0;
  }

  .OrderReview_content__6SzFz {
    width: 100%; /* Asigură lățimea completă */
    padding: 0px; /* Spațiu intern */
    box-sizing: border-box; /* Previne overflow-ul din cauza padding-ului */
    overflow: hidden; /* Ascunde orice element care ar putea depăși */
    margin-top: 0px;
  }

  .OrderReview_cartList__WcVyE,
  .OrderReview_orderSummary__dDda3 {
    flex: 1 1; /* Elemente egale ca dimensiune */
    width: 100%; /* Lățimea completă a containerului părinte */
    box-sizing: border-box; /* Previne overflow-ul */
    padding: 10px; /* Spațiu intern pentru layout clar */
    margin: 0; /* Elimină margini implicite */
  }

  .OrderReview_inlineContainer__pyz\\+4 {
    flex-direction: column; /* Elemente afișate vertical */
    gap: 0px; /* Spațiu între ele */
    width: 100%; /* Asigură că nu depășește containerul părinte */
    box-sizing: border-box; /* Previne overflow-ul */
    margin: 0;
  }

  .OrderReview_continueButton__5cVY4 {
    width: 100%; /* Butonul ocupă toată lățimea */
    box-sizing: border-box; /* Asigură că padding-ul nu cauzează overflow */
    margin: 0 auto; /* Centrare pe orizontală */
  }

  .OrderReview_title__b-6qv {
    width: 100%; /* Asigură că titlul ocupă toată lățimea */
    padding: 10px; /* Spațiu intern */
    box-sizing: border-box; /* Previne overflow-ul */
  }

  .OrderReview_inlineContainer__pyz\\+4 h2 {
    margin: 0;
    padding: 0;
    text-align: left;
  }

  .OrderReview_inlineContainer__pyz\\+4 h2::after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin: 10px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ShoppingChart/OrderReview/OrderReview.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA,qBAAqB;AACrB;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B,EAAE,0BAA0B;EAC1D,gBAAgB,EAAE,0BAA0B;EAC5C,WAAW,EAAE,oBAAoB;EACjC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,MAAM;IACN,SAAS;EACX;;EAEA;IACE,WAAW,EAAE,6BAA6B;IAC1C,YAAY,EAAE,kBAAkB;IAChC,sBAAsB,EAAE,+CAA+C;IACvE,gBAAgB,EAAE,+CAA+C;IACjE,eAAe;EACjB;;EAEA;;IAEE,SAAO,EAAE,iCAAiC;IAC1C,WAAW,EAAE,6CAA6C;IAC1D,sBAAsB,EAAE,wBAAwB;IAChD,aAAa,EAAE,qCAAqC;IACpD,SAAS,EAAE,8BAA8B;EAC3C;;EAEA;IACE,sBAAsB,EAAE,8BAA8B;IACtD,QAAQ,EAAE,qBAAqB;IAC/B,WAAW,EAAE,gDAAgD;IAC7D,sBAAsB,EAAE,wBAAwB;IAChD,SAAS;EACX;;EAEA;IACE,WAAW,EAAE,gCAAgC;IAC7C,sBAAsB,EAAE,+CAA+C;IACvE,cAAc,EAAE,2BAA2B;EAC7C;;EAEA;IACE,WAAW,EAAE,0CAA0C;IACvD,aAAa,EAAE,kBAAkB;IACjC,sBAAsB,EAAE,wBAAwB;EAClD;;EAEA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,cAAc;EAChB;AACF","sourcesContent":["h1 {\n  text-align: center;\n}\n/* Bara de navigare */\n.content {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n  flex-direction: column; /* Elemente pe verticală */\n}\n\n.cartList {\n  width: 71%;\n}\n\n.orderSummary {\n  width: 29%;\n}\n\n.inlineContainer {\n  display: flex;\n  margin: 20px 0;\n  justify-content: space-between; /* Spațiu între elemente */\n  align-items: top; /* Aliniere pe verticală */\n  width: 100%; /* Lățime completă */\n  gap: 20px;\n}\n\n.continueButton {\n  padding: 10px;\n  font-size: 14px;\n  font-weight: bold;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  text-align: center;\n  text-decoration: none;\n  color: inherit;\n  font-weight: normal;\n}\n\n.continueButton:hover {\n  background-color: #f8f8f8;\n  border-color: #ccc;\n}\n\n.continueButton i {\n  padding: 7px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  * {\n    padding: 0;\n    gap: 0;\n    margin: 0;\n  }\n\n  .content {\n    width: 100%; /* Asigură lățimea completă */\n    padding: 0px; /* Spațiu intern */\n    box-sizing: border-box; /* Previne overflow-ul din cauza padding-ului */\n    overflow: hidden; /* Ascunde orice element care ar putea depăși */\n    margin-top: 0px;\n  }\n\n  .cartList,\n  .orderSummary {\n    flex: 1; /* Elemente egale ca dimensiune */\n    width: 100%; /* Lățimea completă a containerului părinte */\n    box-sizing: border-box; /* Previne overflow-ul */\n    padding: 10px; /* Spațiu intern pentru layout clar */\n    margin: 0; /* Elimină margini implicite */\n  }\n\n  .inlineContainer {\n    flex-direction: column; /* Elemente afișate vertical */\n    gap: 0px; /* Spațiu între ele */\n    width: 100%; /* Asigură că nu depășește containerul părinte */\n    box-sizing: border-box; /* Previne overflow-ul */\n    margin: 0;\n  }\n\n  .continueButton {\n    width: 100%; /* Butonul ocupă toată lățimea */\n    box-sizing: border-box; /* Asigură că padding-ul nu cauzează overflow */\n    margin: 0 auto; /* Centrare pe orizontală */\n  }\n\n  .title {\n    width: 100%; /* Asigură că titlul ocupă toată lățimea */\n    padding: 10px; /* Spațiu intern */\n    box-sizing: border-box; /* Previne overflow-ul */\n  }\n\n  .inlineContainer h2 {\n    margin: 0;\n    padding: 0;\n    text-align: left;\n  }\n\n  .inlineContainer h2::after {\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: #ccc;\n    margin: 10px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `OrderReview_content__6SzFz`,
	"cartList": `OrderReview_cartList__WcVyE`,
	"orderSummary": `OrderReview_orderSummary__dDda3`,
	"inlineContainer": `OrderReview_inlineContainer__pyz+4`,
	"continueButton": `OrderReview_continueButton__5cVY4`,
	"title": `OrderReview_title__b-6qv`
};
export default ___CSS_LOADER_EXPORT___;
